import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App'; // Remove .tsx extension
import ErrorBoundary from './components/ErrorBoundary';
import './styles/index.css';

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Clerk Publishable Key");
}

const RootErrorFallback: React.FC = () => (
  <div className="offline-fallback">
    <img src="/gp_commit_logo_1.png" alt="GPCommit" className="offline-logo" />
    <h1>Something went wrong</h1>
    <p>Try refreshing the page. If this keeps happening, check your internet connection.</p>
    <button onClick={() => window.location.reload()} className="offline-button">
      Refresh
    </button>
  </div>
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary fallback={<RootErrorFallback />}>
      <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
        <App />
      </ClerkProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
